import { makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles((theme) => ({
    paper: {
        borderRadius: 4,
        overflowY: 'hidden',
        padding: '8px 8px 20px',
        maxWidth: 560,
    },
    header: {
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'flex-start',
        flexShrink: 0,
        padding: '16px 24px 12px',
    },
    title: {
        fontSize: 22,
        fontWeight: 700,
        lineHeight: 1.2,
    },
    subtitle: {
        marginTop: 4,
        color: theme.palette.text.secondary,
    },
    closeButton: {
        marginTop: -8,
    },
    body: {
        flex: '1 1 auto',
        overflowY: 'auto',
        padding: '8px 16px 4px 24px',
    },
    planName: {
        fontWeight: 600,
        marginBottom: 8,
    },
    planDescription: {
        color: theme.palette.text.secondary,
        marginBottom: 20,
    },
    cta: {
        marginTop: 20,
        padding: '12px 24px',
    },
}));
